import React from "react";
import BasketItem from "../basket/BasketItem";
import { Zoom } from "react-awesome-reveal";
import LoadingPage from "../pages/LoadingPage";

const OrderSummary = ({
  basket,
  removeFromBasket,
  updateItemBasketQuantity,
  minOrderPrice,
}) => {

  return (
    <div className="checkout_section_container">
      <div className="checkout_subtitle_background">
        <h3 className="checkout_subtitle">ORDER SUMMARY</h3>
      </div>
      <div className="order_sum_content">
        {!basket.lines ? (
          <LoadingPage height="130px" />
        ) : (
          <>
            {basket.lines.edges.map(({ node: item }) => (
              <div className="basket_content" key={item.id}>
                <BasketItem
                  key={item.id}
                  id={item.id}
                  title={item.merchandise.product.title}
                  servings={item.merchandise.selectedOptions[0]?.value}
                  quantity={item.quantity}
                  price={item.merchandise.price.amount * item.quantity}
                  image={item.merchandise.product.images.edges[0]?.node.url}
                  removeFromBasket={removeFromBasket}
                  updateItemBasketQuantity={updateItemBasketQuantity}
                />
              </div>
            ))}
            {basket.lines.edges.length !== 0 && (
              <div className="order_sum_item_container">
                <div className="order_sum_item">
                  <h3>SUBTOTAL</h3>
                  <h3>
                    £
                    {parseFloat(
                      basket.estimatedCost.subtotalAmount.amount
                    ).toFixed(2)}
                  </h3>
                </div>
                <div className="divider"></div>

                {basket.estimatedCost.subtotalAmount.amount < minOrderPrice && (
                  <div className="order_sum_min_container">
                    <Zoom triggerOnce={true}>
                      <h3 className="order_sum_min">
                        {" "}
                        (Min order subtotal £{minOrderPrice} - please add more
                        items){" "}
                      </h3>
                    </Zoom>
                  </div>
                )}
              </div>
            )}
          </>
        )}

        {basket?.lines?.edges?.length === 0 && (
          <Zoom triggerOnce={true}>
            <span
              style={{ display: "flex", lineHeight: "28px", fontSize: "15px" }}
            >
              You have no items in your basket, please add some before
              continuing checkout.
            </span>
          </Zoom>
        )}
      </div>
    </div>
  );
};

export default OrderSummary;
